import React, { Component } from "react"
import {
    // sorting
    enumValueSort,
} from "shared/search/containers/Filter/Filters"
import { enumGenericFilter } from "shared/search/containers/Filter/FilterCreators"

export class ProjectTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "projectTypeFilter",
        filterKey: "project_type__in",
        enumItems: DjangIO.app.userdata.types.ProjectType.region_supported_items(),
        sortBy: enumValueSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}
